import { yup } from '@framework/validation/initYup.ts';
import { type IAsyncServiceParameter } from '../../../../../../expressions/repository/async/context/IAsyncService.ts';
import {
  ButtonActionType,
  type IButtonActionExecAsyncService,
} from '../IButtonAction.ts';

export const AsyncServiceActionSchema: yup.ObjectSchema<IButtonActionExecAsyncService> =
  yup.object({
    type: yup.string().exact(ButtonActionType.ExecAsyncService).required(),
    serviceId: yup.string().required().label('Servizio'),
    // TODO Tipizzare
    inputs: yup.mixed().required().label('Parametri di input'),
    outputs: yup
      .array(yup.object() as yup.ObjectSchema<IAsyncServiceParameter>)
      .label('Risultati')
      .optional(),
    enableRequestMessage: yup
      .boolean()
      .label('Abilita messaggio richiesta')
      .notRequired()
      .default(false),
    requestMessage: yup
      .string()
      .label('Messaggio richiesta')
      .notRequired()
      .when('enableRequestMessage', ([enableRequestMessage], schema) => {
        if (enableRequestMessage) {
          return schema.required();
        }
        return schema;
      })
      .default('Esecuzione in corso...'),
    enableSuccessMessage: yup
      .boolean()
      .label('Abilita messaggio successo')
      .notRequired()
      .default(false),
    successMessage: yup
      .string()
      .label('Messaggio successo')
      .notRequired()
      .when('enableSuccessMessage', ([enableSuccessMessage], schema) => {
        if (enableSuccessMessage) {
          return schema.required();
        }
        return schema;
      })
      .default('Esecuzione completata con successo'),
  });
